import React from "react";
import "./signup.scss";
import logo from "../../assets/BankeMainLogo.png";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import signupImage from "../../assets/signup.png";
import http from "../../services/http-commons.js";
import { toast } from "react-toastify";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Modal } from "bootstrap";
// import "bootstrap/dist/js/bootstrap.bundle.min.js";

const SignUp = () => {
  const navigate = useNavigate();

  const signUpData = {
    email: "",
    first_name: "",
    last_name: "",
    affiliate_code: "",
    mobile_number: "",
    gender: "female",
    age: 18,
    role: "customer",
    emailverified: false,
    verificationtoken: "",
    created_at: new Date(),
    updated_at: new Date(),
    last_logged_in: new Date(),
    password: "",
    cpassword: "",
  };

  const [signupCred, setSignupCred] = useState(signUpData);
  const [emailVerification, setEmailVerification] = useState("");
  const [OTPVerification, setOTPVerification] = useState("");
  const [sendBySms, setSendBySms] = useState(true);

  // ============= UseEffects =================
  useEffect(() => {
    // Get the current URL
    const urlParams = new URLSearchParams(window.location.search);
    const affiliateCode = urlParams.get("affiliate_code");

    if (affiliateCode) {
      setSignupCred((prev) => ({
        ...prev,
        affiliate_code: affiliateCode,
      }));
    }
  }, []);

  function handleChange(e) {
    const { name, value } = e.target;
    setSignupCred({ ...signupCred, [name]: value });

    const updatedValue = name === "gender" ? value.toLowerCase() : value;

    setSignupCred({ ...signupCred, [name]: updatedValue });
  }
  function register() {
    setEmailVerification(signupCred.email);
    const registeration = http.USERHTTP.post(`/register`, signupCred);
    toast.promise(
      registeration,
      {
        pending: "Signing up...",
        success: "Sign up successful! 🎉",
        error: "Unable to Sign up 😞",
      },
      {
        autoClose: 3000,
      }
    );
    registeration
      .then((response) => {
        if (response.status === 200) {
          // const modalElement = document.getElementById("staticBackdrop");
          // const bootstrapModal = new bootstrap.Modal(modalElement);
          // bootstrapModal.show();
          const bootstrapModal = new Modal(
            document.getElementById("staticBackdrop")
          );
          bootstrapModal.show();
        }
      })
      .catch((error) => {
        toast.error(
          `${
            error.response.data.detail
              ? error.response.data.detail
              : "An error occured"
          }`,
          {
            autoClose: 3000, // 3 seconds
          }
        );
        console.log("Create-User error", error);
      });
  }

  // ========= Confirm User Account verification ==================
  function VerifiAccount() {
    let emailActicationBody = {
      user_email: emailVerification,
      user_otp: OTPVerification,
    };
    const verifyEmailAccount = http.USERHTTP.post(
      `/email-verification`,
      emailActicationBody
    );
    toast.promise(
      verifyEmailAccount,
      {
        pending: "Acticating Account...",
        success: "Account activated! 🎉",
        error: "Failed to process 😞",
      },
      {
        autoClose: 3000,
      }
    );
    verifyEmailAccount
      .then((response) => {
        if (response.status === 200) {
          const bootstrapModal = new Modal(
            document.getElementById("staticBackdrop")
          );
          bootstrapModal.hide();
          navigate("/auth/login");
          const refreshAfterSignup = setTimeout(() => {
            window.location.reload();
          }, 1000);

          return () => clearTimeout(refreshAfterSignup);
        }
      })
      .catch((error) => {
        toast.error(
          `${
            error.response.data.detail
              ? error.response.data.detail
              : "An error occured"
          }`,
          {
            autoClose: 3000, // 3 seconds
          }
        );
        console.log("Account activation error", error);
      });
  }

  // =========== Trigger media to Send OTP from ============
  function sendOTP(medium) {
    let sendOutOTP = {
      user_email: emailVerification,
      email_channel: medium,
    };
    const registeration = http.USERHTTP.post(`/send-otp`, sendOutOTP);
    toast.promise(
      registeration,
      {
        pending: "Sending OTP...",
        success: "OTP Sent successful! 🎉",
        error: "Unable to send OTP 😞",
      },
      {
        autoClose: 3000,
      }
    );
    registeration
      .then((response) => {
        if (response.status === 200) {
          setSendBySms((prev) => !prev);
        }
      })
      .catch((error) => {
        toast.error(
          `${
            error.response.data.detail
              ? error.response.data.detail
              : "An error occured"
          }`,
          {
            autoClose: 3000, // 3 seconds
          }
        );
        console.log("Send OTP error", error);
      });
  }

  return (
    <div className="signup-holder">
      <div className="signup-content">
        <div className="signup-content-headers">
          <h4>Create an Account</h4>
          <div className="signup-img">
            <Link to="/">
              <img src={logo} alt="..." width={"90px"} height={"45px"} />
            </Link>
          </div>
        </div>
        <div className="signup-content-form">
          <div className="row">
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"firstName"} className="form-label">
                  First Name
                </label>
                <input
                  type="text"
                  name="first_name"
                  value={signupCred.first_name}
                  onChange={handleChange}
                  className="form-control"
                  id={"firstName"}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"last_name"} className="form-label">
                  Surname
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="last_name"
                  value={signupCred.last_name}
                  onChange={handleChange}
                  id={"last_name"}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"contactEmail"} className="form-label">
                  Email Address
                </label>
                <input
                  type="email"
                  name="email"
                  value={signupCred.email}
                  placeholder="xxxxxx@gmail.com"
                  onChange={handleChange}
                  className="form-control"
                  id={"contactEmail"}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"mobile_number"} className="form-label">
                  Mobile
                </label>
                <input
                  type="number"
                  name="mobile_number"
                  value={signupCred.mobile_number}
                  placeholder="+23481********"
                  onChange={handleChange}
                  className="form-control"
                  id={"mobile_number"}
                />
              </div>
            </div>
            {/* <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"gender"} className="form-label">
                  Gender
                </label>
                <select
                  name="gender"
                  value={signupCred.gender}
                  onChange={handleChange}
                  className="form-control"
                  id="gender"
                >
                  <option disabled value="">
                    Select Gender
                  </option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                </select>
              </div>
            </div> */}
            {/* <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"age"} className="form-label">
                  Age
                </label>
                <input
                  type="number"
                  name="age"
                  value={signupCred.age}
                  onChange={handleChange}
                  className="form-control"
                  id={"age"}
                />
              </div>
            </div> */}
            <div className="col-md-12">
              <div className="mb-3 affilate-style">
                <label htmlFor={"affiliate_code"} className="form-label">
                  Affiliate Code
                </label>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id="tooltip-top">This field is optional</Tooltip>
                  }
                  trigger={["hover", "focus", "click"]}
                >
                  <input
                    type="text"
                    name="affiliate_code"
                    value={signupCred.affiliate_code}
                    onChange={handleChange}
                    className="form-control"
                    id="affiliate_code"
                    placeholder="You can still proceed without your affiliate code"
                  />
                </OverlayTrigger>
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"password"} className="form-label">
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  value={signupCred.password}
                  placeholder="********"
                  onChange={handleChange}
                  className="form-control"
                  id={"password"}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="mb-3">
                <label htmlFor={"cpassword"} className="form-label">
                  Confirm Password
                </label>
                <input
                  type="password"
                  name="cpassword"
                  value={signupCred.cpassword}
                  placeholder="********"
                  onChange={handleChange}
                  className="form-control"
                  id={"cpassword"}
                />
              </div>
            </div>
          </div>

          <p>
            By Signing up to Banke store, you agree to our{" "}
            <Link to="/policies">Terms of Service and Privacy Policy</Link>
          </p>
          <div className="mb-3 style-button">
            <button className="btn btn-primary col-12" onClick={register}>
              Sign up
            </button>
          </div>
        </div>
        <p style={{ textAlign: "center", marginBottom: "0" }}>
          Already have an account? <Link to="/auth/login">Login</Link> or{" "}
          <span
            style={{ color: "#1E90FF", cursor: "pointer", fontSize: "14px" }}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            Activate account
          </span>
        </p>
      </div>
      <div className="signup-image">
        <img src={signupImage} alt="..." />
      </div>

      {/* ---------MODALS------------- */}
      {/* Confirm OTP and Activate Email account */}
      <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="container-fluid modal-content">
            <p
              data-bs-dismiss="modal"
              className="d-flex justify-content-end align-items-center"
            >
              <i
                style={{ cursor: "pointer" }}
                className="fa-solid fa-xmark"
              ></i>
            </p>
            <div
              style={{ width: "25%", marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={logo} alt="Banke" width={"100px"} height={"50px"} />
            </div>
            <div>
              <h4
                style={{
                  fontSize: "21px",
                  fontWeight: "700",
                  style: "bold",
                  color: "#061D33",
                  fontFamily: "Montserrat",
                  marginBottom: "0",
                }}
              >
                Email verification
              </h4>
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  textAlign: "justify",
                  color: "#7B7B7B",
                  paddingBottom: "0",
                  paddingTop: "0",
                  marginTop: "0",
                  marginBottom: "12px",
                }}
              >
                Input the OTP code sent to you to verify and activate your
                account.
              </p>
            </div>
            <form>
              <div className="mb-3">
                <label
                  style={{ color: "grey" }}
                  htmlFor={"verifyEmail"}
                  className="form-label"
                >
                  <strong>Email</strong>
                </label>
                <input
                  type="text"
                  className="form-control activate-email"
                  id={"verifyEmail"}
                  value={emailVerification}
                  onChange={(e) => setEmailVerification(e.target.value)}
                />
              </div>
              <div className="no-margin">
                <label
                  style={{ color: "grey" }}
                  htmlFor={"verifyOTP"}
                  className="form-label"
                >
                  <strong>Confirm OTP</strong>
                </label>
                <input
                  type="text"
                  className="form-control activate-email"
                  id={"verifyOTP"}
                  placeholder="123456"
                  value={OTPVerification}
                  onChange={(e) => {
                    setOTPVerification(e.target.value);
                  }}
                />
              </div>
              <p
                style={{
                  color: "#1E90FF",
                  fontSize: "12px",
                  cursor: "pointer",
                  marginTop: "0",
                }}
                onClick={() => (sendBySms ? sendOTP("sms") : sendOTP("email"))}
              >
                send otp via {sendBySms ? "sms" : "email"}
              </p>
            </form>
            <div>
              <button
                type="button"
                className="btn btn-primary col-12"
                onClick={VerifiAccount}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Confirm password CREATION */}
      {/* <div
        className="modal fade"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="container-fluid modal-content">
            <p
              data-bs-dismiss="modal"
              className="d-flex justify-content-end align-items-center"
            >
              <i style={{ cursor: "pointer" }} className="fa-solid fa-xmark"></i>
            </p>
            <div
              style={{ width: "20%", marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={logo} alt="Banke" width={"70px"} height={"40px"} />
            </div>
            <div>
              <h4 style={{ fontSize: "16px", textAlign: "center" }}>
                {"FirstName"}, your account has been created
              </h4>
            </div>
            <div>
              <button type="button" className="btn btn-primary col-12">
                Return back to login
              </button>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default SignUp;
